import React from "react";

// Animation
import { Fade } from "react-awesome-reveal";

// components
import CartLibraries from "components/Carts/CartsBanner";

// Actions
import { useAppSelector } from "lib/hooks/useDispatch";

// Lib
import { shallowEqual } from "react-redux";

// Type
import { CompoundLibType } from "../type";
import { UnitLibraries } from "pages/Libraries/type";

export const CompoundLib: React.FC = () => {
  const {
    diseases,
    bioActive,
    compoundsCount,
    drugRepurposing,
    signalingPathways
  } = useAppSelector(
    (store) => {
      return {
        diseases: store.libraries.diseases,
        bioActive: store.libraries.bioActive,
        compoundsCount: store.libraries.compoundsCount,
        drugRepurposing: store.libraries.drugRepurposing,
        signalingPathways: store.libraries.signalingPathways,
      };
    },
    shallowEqual
  );

  const getTags = (data: UnitLibraries[]) => {
    return data?.length ? data?.slice(0, 3)?.map((x) => {
      return {
        id: x.catNumber,
        name: `${x.name} (${x.compoundsCount})`
      };
    }) : [];
  };

  const compoundLib: CompoundLibType[] = [
    {
      id: 1,
      img: "compLib1",
      tags: getTags(bioActive),
      title: "Bioactive Screening Compound Libraries",
      text: bioActive.length ? `We provide <b>${bioActive.length}</b> libraries with a total of <b>${compoundsCount.compoundsType1}</b> compounds` : ""
    },
    {
      id: 2,
      img: "compLib2",
      tags: getTags(drugRepurposing),
      title: "Drug Repurposing and Related Libraries",
      text: drugRepurposing.length ? `We provide <b>${drugRepurposing.length}</b> libraries with a total of <b>${compoundsCount.compoundsType2}</b> compounds` : ""
    },
    {
      id: 3,
      img: "compLib3",
      tags: getTags(signalingPathways),
      title: "Signaling Pathways and Protein Classes Related Libraries",
      text: signalingPathways.length ? `We provide <b>${signalingPathways.length}</b> libraries with a total of <b>${compoundsCount.compoundsType3}</b> compounds` : ""
    },
    {
      id: 4,
      img: "compLib4",
      tags: getTags(diseases),
      title: "Disease Related Compound Libraries",
      text: diseases.length ? `We provide <b>${diseases.length}</b> libraries with a total of <b>${compoundsCount.compoundsType4}</b> compounds` : ""
    }
  ];

  return (
    <div className="section-compound-lib">
      <Fade triggerOnce direction="up">
        <h4 className="wrapper section-compound-lib__title">
          EBC Libraries
        </h4>
      </Fade>

      <div className="wrapper section-compound-lib__list">
        <Fade cascade triggerOnce duration={500} direction="left">
          {compoundLib.map((item, i: number) => {
            return <CartLibraries {...item} key={item.id || "" + i} />;
          })}
        </Fade>
      </div>
    </div>
  );
};

export default CompoundLib;
